import GridViewIcon from "@mui/icons-material/GridView";
import MotorInsurance from "./pages/POSP/Products/MotorInsurance";
import RollOver from "./pages/POSP/Products/MotorInsurance/components/RollOver";
import VehicleDetails from "./pages/POSP/Products/MotorInsurance/components/RollOver/components/VehicleDetails";
import PreviousPolicy from "./pages/POSP/Products/MotorInsurance/components/RollOver/components/PrivousPolicy";
import NewCar from "./pages/POSP/Products/MotorInsurance/components/NewCar";
import Signin from "./pages/authentication/signin";
import Details from "./pages/POSP/Products/MotorInsurance/components/Details";
import PlanProposalFlow from "./pages/POSP/Products/MotorInsurance/components/PlanProposalFlow";
import Products from "./pages/POSP/Products";
import Proposal from "./pages/POSP/Products/MotorInsurance/components/PlanProposalFlow/components/Proposal";
import PaymentFlow from "./pages/POSP/Products/MotorInsurance/components/PaymentFlow";
import { PaymentCard } from "./pages/POSP/Products/MotorInsurance/components/PaymentFlow/component/PaymentCard";
import { PaymentSuccess } from "./pages/POSP/Products/MotorInsurance/components/PaymentFlow/component/PaymentSuccess";
import InsuranceDetails from "./pages/POSP/Products/MotorInsurance/components/pdf";
//general health components
import Insurance from "./pages/GeneralHealth/configuration/insurance/insurance";
import Company from "./pages/GeneralHealth/configuration/company/company";
import Plan from "./pages/GeneralHealth/configuration/plan/plan";
import SettingsIcon from "@mui/icons-material/Settings";
import Wallet from "./pages/GeneralHealth/configuration/wallet/wallet";
import Buy from "./pages/GeneralHealth/buy/buy";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Plans from "./pages/GeneralHealth/buy/plans";
import HistoryIcon from "@mui/icons-material/History";
import History from "./pages/GeneralHealth/history";
import AuthLoader from "./pages/authLoader";

export const routes = [
  {
    key: "products",
    route: "/sign-in",
    icon: <GridViewIcon />,
    component: <Signin />,
    noCollapse: true,
    protected: true,
  },
  {
    key: "product-list",
    route: "/products/list",
    component: <Products />,
    noCollapse: true,
    protected: true,
  },
];

export const Genralroutes = [
  {
    key: "products",
    route: "/sign-in",
    icon: <GridViewIcon />,
    component: <Signin />,
    noCollapse: true,
    protected: true,
  },
  {
    key: "authentication",
    route: "/authentication",
    icon: <GridViewIcon />,
    component: <AuthLoader />,
    noCollapse: true,
    protected: true,
  },
  {
    key: "product-list",
    route: "/products/list",
    component: <Products />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    name: "Configuration",
    key: "Configuration",
    roleAcess: true,
    icon: <SettingsIcon />,
    collapse: [
      {
        name: "Insurance Config",
        // action: ["Edit", "View", "Delete", "Create"],
        roleAcess: true,
        key: "insurance",
        route: "/insurance",
        component: <Insurance />,
      },
      {
        name: "Plan Config",
        // action: ["Edit", "View", "Delete", "Create", "Export"],
        roleAcess: true,
        key: "position",
        route: "/plan",
        component: <Plan />,
      },
      {
        name: "Company Config",
        // action: ["Edit", "View", "Delete", "Create", "Export"],
        roleAcess: true,
        key: "compnay",
        route: "/company",
        component: <Company />,
      },
      {
        name: "Wallet Config",
        // action: ["Edit", "View", "Delete", "Create", "Export"],
        roleAcess: true,
        key: "wallet",
        route: "/wallet",
        component: <Wallet />,
      },
    ],
  },
  {
    type: "collapse",
    key: "buy-plan",
    name: "Buy Plan",
    route: "/buy-plan",
    roleAcess: true,
    icon: <ShoppingCartIcon />,
    component: <Buy />,
    noCollapse: true,
    protected: true,
  },
  {
    key: "plan-details",
    route: "/buy-plan/health-plan-details",
    component: <Plans />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    key: "history",
    name: "History",
    route: "/history",
    roleAcess: true,
    icon: <HistoryIcon />,
    component: <History />,
    noCollapse: true,
    protected: true,
  },
];
